/**
 * A Date from whatever a row carries — a Date, an ISO string, or nothing.
 * Invalid and empty values are null, never an "Invalid Date" that NaNs every
 * comparison after it. One copy; the item journey page re-exports it.
 */
export function toDate(val: unknown): Date | null {
  if (!val) return null;
  if (val instanceof Date) return Number.isNaN(val.getTime()) ? null : val;
  const d = new Date(val as string);
  return Number.isNaN(d.getTime()) ? null : d;
}
